import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["all", "item", "count", "action", "scope", "pagePrompt", "allPrompt", "operation", "operationFields"]
  static values = { totalCount: Number }

  connect() {
    this.update()
  }

  toggleAll() {
    if (this.hasScopeTarget) this.scopeTarget.value = "page"
    this.itemTargets.forEach((item) => { item.checked = this.allTarget.checked })
    this.update()
  }

  selectAllMatching() {
    this.scopeTarget.value = "all"
    this.itemTargets.forEach((item) => { item.checked = true })
    this.update()
  }

  clearAll() {
    if (this.hasScopeTarget) this.scopeTarget.value = "page"
    this.itemTargets.forEach((item) => { item.checked = false })
    this.update()
  }

  update(event) {
    if (this.hasScopeTarget && event && ((this.hasAllTarget && event.target === this.allTarget) || this.itemTargets.includes(event.target))) {
      this.scopeTarget.value = "page"
    }

    if (this.hasScopeTarget && this.scopeTarget.value === "all") {
      if (this.hasCountTarget) this.countTarget.textContent = this.totalCountValue
      this.updateActions(this.totalCountValue === 0)
      this.updateHeader(this.totalCountValue > 0, false)
      if (this.hasPagePromptTarget) this.pagePromptTarget.hidden = true
      if (this.hasAllPromptTarget) this.allPromptTarget.hidden = false
      return
    }

    const selected = this.itemTargets.filter((item) => item.checked).length
    if (this.hasCountTarget) this.countTarget.textContent = selected
    this.updateActions(selected === 0)
    this.updateHeader(selected > 0 && selected === this.itemTargets.length, selected > 0 && selected < this.itemTargets.length)
    if (this.hasPagePromptTarget) this.pagePromptTarget.hidden = selected === 0 || selected !== this.itemTargets.length || selected >= this.totalCountValue
    if (this.hasAllPromptTarget) this.allPromptTarget.hidden = true
  }

  updateActions(disabled) {
    this.actionsDisabled = disabled
    this.actionTargets.forEach((action) => { action.disabled = disabled })
    this.updateOperationFields()
  }

  updateOperationFields() {
    if (!this.hasOperationTarget) return

    this.operationFieldsTargets.forEach((fields) => {
      const operations = (fields.dataset.bulkSelectionOperations || "").split(/\s+/)
      const visible = operations.includes(this.operationTarget.value)
      fields.hidden = !visible
      fields.disabled = this.actionsDisabled || !visible
    })
  }

  updateHeader(checked, indeterminate) {
    if (!this.hasAllTarget) return

    this.allTarget.checked = checked
    this.allTarget.indeterminate = indeterminate
  }
}
